<template>
  <div
    class="child-card-wrap"
    :class="{ active: previewOpened }"
    @click.stop.prevent="handleClick"
  >
    <CircularProgress
      :transition-duration="500"
      :radius="progressRadius"
      :stroke-width="progressStrokeWidth"
      :value="circularValue"
      class="card-attachment-load-spiner-child-card"
      :allow-zero-value="true"
      :color-variation="'gray'"
    />
    <span
      class="count-number"
      :class="{ 'mr-1': !hasExpandButton }"
      >{{ doneCardsCount }}/{{ cardsCount }}</span
    >
    <em
      v-if="hasExpandButton"
      :style="buttonIconStyle"
      class="custom-icons small-card-info-icons usn"
    />
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';
import CircularProgress from '@/components/elements/CircularProgress';

export default {
  name: 'ChildCardsPreviewButton',
  components: {
    CircularProgress,
  },
  mixins: [customIconsMixin],
  props: {
    cardsCount: {
      type: Number,
      required: true,
    },
    doneCardsCount: {
      type: Number,
      required: true,
    },
    startedCardsCount: {
      type: Number,
      required: true,
    },
    hasExpandButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    previewOpened: {
      type: Boolean,
      required: false,
      default: false,
    },
    progressRadius: {
      type: Number,
      required: false,
      default: 4.5,
    },
    progressStrokeWidth: {
      type: Number,
      required: false,
      default: 1.5,
    },
  },
  emits: ['click'],
  computed: {
    degrees() {
      return (this.doneCardsCount + this.startedCardsCount) / this.cardsCount;
    },
    circularValue() {
      return this.degrees * 100;
    },
    buttonIconStyle() {
      return this.previewOpened
        ? this.getCustomIconStyle(this.iconPath('chevron-up'))
        : this.getCustomIconStyle(this.iconPath('chevron-down'));
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
.child-card-wrap {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid $primary50;
  max-width: fit-content;
  height: 18px;
  box-sizing: border-box;
  @apply text-deEmphasised-text bg-emphasised-bg border-emphasised-border;

  &:hover {
    @apply bg-emphasised-hover;
  }

  .count-number {
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1px;
  }

  .small-card-info-icons {
    margin-right: 3px;
    @apply my-0.5 ml-0.5;
  }

  &.in-tab-progress {
    .count-number {
      @apply text-sm;
    }
  }
}
.progress-circle {
  border-radius: 50%;
  width: 12px;
  height: 12px;
  transition: all 500ms ease-in;
  will-change: transform;

  // For animations...
}
.card-attachment-load-spiner-child-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-right: 4px;
  margin-left: 3px;
  @apply my-0.5;
  * {
    display: flex;
    align-items: center;
  }
}
</style>
